import { SidebarOption } from '../components/date-range-picker/types';
import { TimeRangeType } from '../context/TimeRangeContext';

// Helper function to map sidebar option to TimeRangeType
export const mapOptionToRange = (option: SidebarOption): TimeRangeType => {
  switch (option) {
    case '24 hours':
      return '24H';
    case '7 days':
      return '7D';
    case '14 days':
      return '14D';
    case '30 days':
      return '30D';
    case '90 days':
      return '90D';
    case 'six months':
      return '6M';
    case '1 year':
      return '1Y';
    case 'POP':
      return 'POP';
    case 'Current compl.':
      return 'Current compl.';
    default:
      return '7D';
  }
};
